import { Component, OnInit } from '@angular/core';
import { SiteconfigService } from '../../../api/siteconfig/siteconfig.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { Title } from '@angular/platform-browser';
// import {ToasterService} from '../../toaster-service.service';
declare var $: any;
declare var jQuery: any;
declare var autosize: any;
@Component({
    selector: 'application-page',
    templateUrl: './siteconfig.html'
})

export class Siteconfig implements OnInit {
    keyword : string ;
    value : string;
    siteconfigdata = [];
    keywordsiteconfig = [];
    description : string;
    id : string;
   
    i : number;
    constructor(private siteconfigservice : SiteconfigService) {

    }

    ngOnInit() {
        this.siteconfigservice.allsiteconfig().then(data =>{
            
            if(data != null){
                this.siteconfigdata = data;
             

                for(let i=0; i<this.siteconfigdata.length ; i++){

                    this.keywordsiteconfig.push(this.siteconfigdata[i].keyword);
                  
        
                }
              
            }
        })

       
      
    
        
    }

    cancelAction(){
        this.keyword = "";
        this.value = "";
        this.description = "";
      
    }

    submitkeyword(){
        
       
       if(this.keywordsiteconfig.includes(this.keyword)){
        $.notify({
            message: "Please Try With Another Keyword."
        }, {
            type: 'danger',
            placement: {
                from: 'bottom',
                align: 'right'
            },
            delay: 100,
            timer: 100
        });  
        this.cancelAction(); 
       }
       else{


        if (this.keyword == undefined || this.keyword == "") {
            $.notify({
                message: "Please Enter Keyword."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
        }
      
        else {
            var appData = {
                keyword: this.keyword,
                value : this.value,
                description : this.description
            }
            this.siteconfigservice.ikeyword(appData).then(data => {

                if(data.status){
                    this.siteconfigdata.push(data.data);
                    $.notify({
                        message: "Successfully Inserted"
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                this.cancelAction();

                }
                else{

                    $.notify({
                        message: "Error in insertion "
                    }, {
                        type: 'Danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });

                }


            })
        }


       }

 

    }

    showkeyword(data, i ){
        this.keyword = data.keyword;
        this.value = data.value;
        this.i = i;  
        this.description = data.description;   

    }

    updatekeyword(){

        

        if (this.keyword == undefined || this.keyword == "") {
            $.notify({
                message: "Please Enter Value of Keyword."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
        }
        else {
            var appData = {
                keyword: this.keyword,
                value : this.value,
                description : this.description
            }
            this.siteconfigservice.usiteconfig("3",appData).then(data => {

                if(data.status){
                 
                    this.siteconfigdata[this.i] = data.data ;
                  
                    $.notify({
                        message: "Successfully Updated"
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                this.cancelAction();

                }
                else{

                    $.notify({
                        message: "Error in Updation "
                    }, {
                        type: 'Danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });

                }


            })


        }


    }
    
    deleteconfirmation(id,i){
       
        this.id = id; 
        this.i = i;
    }
    deletekeyword()
    {
       
        this.siteconfigservice.dkeyword(this.id).then(data => {
            if(data.status){

                this.siteconfigdata.splice(this.i, 1);
                $.notify({
                    message: "Successfully  Deleted Keyword "
                }, {
                    type: 'Success',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });

            }
            else{

                $.notify({
                    message: "Error in Delete Keyword "
                }, {
                    type: 'Danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });

            }

        })
       

    }
}





// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/siteconfig/siteconfig.page.ts